import { computed } from '@angular/core';
import {
  patchState,
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { NotificationState } from './notification.state';
import { StateFilter } from '../crud.state';
import { Notification } from '../../models/notification';

const filterItems = (
  items: Notification[],
  filter: StateFilter,
  products = false
) => {
  return items.filter(item => {
    const titleMatch = item.title
      .toLowerCase()
      .includes(filter.query.toLowerCase());

    const idMatch =
      !filter.ids ||
      filter.ids.length === 0 ||
      filter.ids.includes(item._id) ||
      filter.ids.includes(item._id);

    return titleMatch && idMatch;
  });
};

export function withNotificationSelectors() {
  return signalStoreFeature(
    {
      state: type<NotificationState>(),
    },
    withComputed(({ items, filter, selectedId }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => {
        return Object.values(items()).sort((a, b) =>
          (a.createdAt || 0) > (b.createdAt || 1) ? -1 : 1
        );
      }),
      publishedAsArray: computed(() => {
        return Object.values(items())
          .filter(item => !item.locked)
          .sort((a, b) => ((a.createdAt || 0) > (b.createdAt || 1) ? -1 : 1));
      }),
      filteredSortedByName: computed(() => {
        let filtered = Object.values(items());
        if (filter()) {
          filtered = filterItems(filtered, filter());
        }
        return filtered.sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
    })),

    withMethods(store => ({
      /**
       * select the newest store-item
       */
      selectLast(): void {
        const allPublished = Object.values(
          Object.values(store.items()).filter(
            (item: Notification) => !item.locked
          )
        ) as Notification[];
        const lastIndex = allPublished.length - 1;
        patchState(store, () => ({
          selectedId: allPublished.at(lastIndex)?._id || undefined,
        }));
      },
    }))
  );
}
